import React from 'react';

const Error403 = () => {
  return <div>Error403</div>;
};

Error403.propTypes = {};

export default Error403;
